import Cookies from "js-cookie";
export const Token = Cookies.get("authToken");